import styled from 'styled-components';

export const OrderBox = styled.div`
    background-color: #fff;
    padding: 20px;
    margin: 15px;
    border-radius: 15px;
    box-shadow: 0 0 5px rgba(0,0,0,0.1);
    color: #136713;
`;

export const OrderTitle = styled.h3`
    margin-bottom: 10px;
`;

export const OrderInfo = styled.div`
    margin-bottom: 10px;
`;

export const OrderProduct = styled.div`
   
`;

export const OrderTotal = styled.div`
    font-size: 16px;
    font-weight: bold;
    color: #2e8b57;
`;

export const StatusText = styled.div`
    margin-top: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #136713;
`;

export const ButtonArea = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
`;

export const Button = styled.button`
    background-color: #136713;
    color: #FFF;
    border: none;
    border-radius: 5px;
    margin: 0 5px;
    padding: 10px 20px;
    cursor: pointer;
`;
